import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Box, Button } from '@mui/material'
import { BACKEND_URI } from '../config'


const categories = [
  'Artillery',
  'Assortments',
  'Fountains',
  'Sparklers',
  'Black Cats',
  'Roman Candles',
  'Cakes',
  'Small Cakes',
  'Poppers',
  'Kid Friendly',
  'Missiles',
]

function Categories({ onLogout, setItems }) {
  const navigate = useNavigate()
  const location = useLocation()
  const [category, setCategory] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!location.pathname.startsWith('/fireworks')) {
      setCategory(null)
    }
  }, [location.pathname])

  const handleCategoryClick = async category => {
    setCategory(category)
    const formattedCategory = category.replace(/ /g, '_') // Replace spaces with underscores
    navigate(`/fireworks/${category.toLowerCase()}`)
    const token = localStorage.getItem('token') // Retrieve the JWT from localStorage
    fetch(`${BACKEND_URI}/api/fireworks?category=${formattedCategory}`, {
      method: 'GET', // Optional since GET is the default
      headers: {
        'Content-Type': 'application/json', // Inform server of JSON format
        Authorization: `Bearer ${token}`, // Add the token here
      },
    })
      .then(response => {
        if (!response.ok) {
          onLogout()
        }
        return response.json()
      })
      .then(data => setItems(data))
      .catch(err => setError(err.message))
  }

  if (error) {
    return <p>Error: {error}</p>
  }

  return (
    <div style={styles.backgroundStyle}>
      {/* Categories displayed as a grid */}
      <Box style={styles.categories}>
        {categories.map(cat => (
          <Button
            key={cat}
            variant={category === cat ? 'contained' : 'outlined'}
            color='#000'
            onClick={() => handleCategoryClick(cat)}
            style={{
              ...styles.categoryButton,
              backgroundColor: category === cat ? '#f7733b' : '#D3D3D3', // Change color based on selected category
              fontWeight: category === cat ? 'bold' : '',
              // color: category === cat.toLowerCase() ? "#fff" : "#fff", // Adjust text color if needed
            }}
            disabled={category === cat ? true : false}
          >
            {cat}
          </Button>
        ))}
      </Box>
    </div>
  )
}

const styles = {
  categories: {
    display: 'flex',
    flexWrap: 'wrap', // ✅ Allows buttons to wrap on mobile
    justifyContent: 'center', // ✅ Centers items
    //   gap: "5px", // ✅ Small space between buttons
    //   padding: "10px", // ✅ Adds padding for better layout
    width: '100%',
  },
  categoryButton: {
    flex: '1 1 auto', // ✅ Makes buttons responsive
    minWidth: '100px', // ✅ Prevents buttons from shrinking too much
    maxWidth: '200px', // ✅ Controls maximum button width
    height: '50px', // ✅ Ensures consistent height
    textAlign: 'center',
    backgroundColor: '#000', // Default background
    border: '1px',
    color: '#000', // Example text color
    textTransform: 'uppercase',
    borderRadius: '0px',
    padding: '10px 0',
  },
}

export default Categories
